import React from 'react';

import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';

const datify = input => {
  if (!input) {
      return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
      throw new Error(`Invalid date: ${input}`);
  }

  return date;
};

const timefy = input =>{
  return input !== ''? new Date(input) : null;
}


export const renderTextField = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...rest}
    {...input}
    onChange={(event, value) => input.onChange(value)}
    hintText={label}
    floatingLabelText={label}
    style={{marginLeft: 10, marginRight:10}}
    errorText={touched && error}/>
)
export const renderTextFieldCustomer = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...rest}
    {...input}
    onChange={(event, value) => input.onChange(value)}
    fullWidth={true}
    hintText={label}
    style={{marginRight:10}}
    floatingLabelText={label}
    errorText={touched && error}/>
)

export const renderTextFieldView = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...rest}
    {...input}
    disabled={true}
    hintText={label}
    floatingLabelText={label}
    underlineStyle={{display: 'none'}}
    errorText={touched && error}/>
)

export const renderMultiTextField = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...input}
    {...rest}
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    multiLine={true}
    fullWidth={true}
    rows={5}/>
)

export const renderSelectField = ({ input, label, meta: {touched, error}, children, ...rest }) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    children={children}
    {...rest} />
);


export const renderDateField = ({input, label, meta: {touched, error}, elStyle, disabled, ...options}) => (
  <DatePicker
    {...input}
    disabled={disabled}
    errorText={touched && error}
    floatingLabelText={label}
    container="dialog"
    DateTimeFormat={Intl.DateTimeFormat}
    value={datify(input.value)}
    onChange={(event, value) => input.onChange(value)}
    onBlur={(event, value) => input.onBlur(value)}
    style= {{marRight:10}} />
);
export const renderTimeField = ({input, label, meta: {touched, error}, elStyle, disabled }) => (
  <TimePicker
    {...input}
    disabled={disabled}
    format="ampm"
    errorText={touched && error}
    floatingLabelText={label}
    value={timefy(input.value)}
    onBlur={(event, value) => input.onBlur(value)}
    onChange={(event, value) => input.onChange(value)}
    style={elStyle}  />
);



// WEBPACK FOOTER //
// ./src/orders/OrderFormField.js